import { Route, Routes } from 'react-router-dom';

import MembershipPacksPage from './membership-packs-page';
import MembershipsPage from './memberships-page';

export default function Memberships() {
    return (
        <Routes>
            <Route
                path="/packs"
                element={<MembershipPacksPage />}
            />

            <Route
                path="/:id?"
                element={<MembershipsPage />}
            />
        </Routes>
    );
}